export const SHADOW = "2px 2px 6px black"
export const BORDER_RADIUS = "5px"